export default __webpack_public_path__ + "static/media/metaverse-Pic.2b078a78.svg";